export default __webpack_public_path__ + "static/media/Wrap of the Dragon King.0978af3f.jpg";